<template>
  <div id="footer">
    <div id="footer-content">
      <span class="footer-normal">{{$t("footer.questions")}}</span>
      <span class="footer-big">
        <a href="tel:+43761721515">+43 7617 21515</a>
      </span>
      <span class="footer-normal">{{$t("footer.or")}}</span>
      <span class="footer-big">
        <a href="mailto:info@kisi.org">info@kisi.org</a>
      </span>
      <a href="https://kisi.org">
        <img src="../../assets/img/logo-white.png">
      </a>
      <div class="footer-links">
        <router-link :to="'/' + $i18n.locale.split('-')[0] + '/' + $t('legal.link')">{{$t("legal.title")}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ruth-footer"
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

#footer {
  //background-image: url("../../assets/img/footer.jpg");
  background-color: $container_background_color;
  height: 620px;
  padding-top: 250px;
}

#footer-content {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .footer-normal, .footer-big {
    width: 100%;
    display: inline-block;
  }

  .footer-big {
    font-family: $condensed_font;
    font-size: 40px;
    font-weight: 700;
    margin: -5px 0;

    @include media-phone {
      font-size: 25px;
    }
  }

  img {
    width: 75px;
    margin: 40px;
  }

  .footer-links, .footer-normal {
    font-family: $condensed_font;
    font-size: 20px;
  }

  a, a:hover {
    color: inherit;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalSegments/Footer.vue